import { Component, input, InputSignal, output, OutputEmitterRef, signal, WritableSignal, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { WidgetsService } from '@modules/widgets-module/services/widgets.service'
import { TranslatePipe } from '@ngx-translate/core'
import { TableSearchAssetsComponent } from '@shared/components/trading/search-assets-dialog/table-search-assets/table-search-assets.component'
import { TuiAutoFocus } from '@taiga-ui/cdk'
import { TuiInputModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy'
import { GridsterItemConfig } from 'angular-gridster2'
import { GridsterService } from '@shared/services/gridster.service'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import { LiveTickerService } from '@modules/stocks-module/live-ticker/services/live-ticker.service'
import { SearchAssetsItemInterface } from '@modules/stocks-module/general/interfaces/search-assets-item.interface'

@UseLocales({ ru, en })
@Component({
	selector: 'app-search-assets-dialog',
	templateUrl: './search-assets-dialog.component.html',
	styleUrl: './search-assets-dialog.component.scss',
	imports: [
		TuiInputModule,
		TuiTextfieldControllerModule,
		TableSearchAssetsComponent,
		FormsModule,
		TranslatePipe,
		TuiAutoFocus,
	],
})
export class SearchAssetsDialogComponent {
	public widget: InputSignal<WidgetInterface | null> = input<WidgetInterface | null>(null)
	public closeDialog: OutputEmitterRef<void> = output<void>()

	private readonly _widgetsService: WidgetsService = inject<WidgetsService>(WidgetsService)
	private readonly _gridsterService: GridsterService = inject<GridsterService>(GridsterService)
	private readonly _liveTickerService: LiveTickerService = inject<LiveTickerService>(LiveTickerService)

	protected searchValue: WritableSignal<string | null> = signal<string | null>(null)
	protected onSelectAsset(asset: SearchAssetsItemInterface): void {
		const widget: WidgetInterface | null = this.widget()
		if (widget) {
			const widgetSizes: GridsterItemConfig | null = this._gridsterService.calcMaxWidgetSize(widget)
			this._widgetsService.createWidget(widget, widgetSizes)
		}

		this._widgetsService.setLiveTickerToDashboard(asset.symbol)
		if (this._widgetsService.hasWidgetsNeedTicker()) {
			this._liveTickerService.launchLiveTicker(asset.symbol)
		}

		this.closeDialog.emit()
	}
}
